import React, { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { BASE_URL } from "../api/api";
import { AuthContext } from "../context/AuthContext";

export default function RemarksLogsPage() {
    const { aa_number } = useParams();
    const navigate = useNavigate();
     const [aaLogs, setAaLogs] = useState([]);
    const { user } = useContext(AuthContext);
    const [aaLoading, setAaLoading] = useState(true);
  useEffect(() => {
    fetchAaLogs(); 
  }, [aa_number]);
console.log(aa_number,'fkfkfkk')
  const fetchAaLogs = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/GetLogsAndRemarksTrackingByAA?AA_Number=${aa_number}`
      );
      const data = await response.json();

      if (Array.isArray(data) && data.length > 0 && Array.isArray(data[0].data)) {
        const formattedAaLogs = data[0].data.map((item, index) => {
          const dateObj = new Date(item.created_Date);
          return {
            sno: index + 1,
            remarks: item.remarks,
            logs: item.logs,
            remarkBy: item.remarkAndLogBy,
            date: dateObj.toLocaleDateString("en-GB"),
            time: dateObj.toLocaleTimeString("en-US", {
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
            }),
          };
        });
        setAaLogs(formattedAaLogs);
      } else {
        setAaLogs([]);
      }
    } catch (error) {
      console.error("Error fetching AA logs:", error);
      setAaLogs([]);
    } finally {
      setAaLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="p-6 bg-gray-50 min-h-screen">
        <button
          className="btn btn-primary d-flex align-items-center"
          style={{
            backgroundColor: "#8000d7",
            border: "none",
            padding: "10px 16px",
            borderRadius: "8px",
            fontWeight: "500",
            fontSize: "14px",
          }}
          onClick={() => navigate(-1)}
        >
          <ArrowBackIcon className="me-1" />
          Back
        </button>

        <h3 className="text-2xl font-bold text-gray-800 mb-4 mt-4">
           Logs & Remarks <span className="text-gray-500">:{aa_number}</span>
        </h3>

        {aaLoading ? (
          <p className="text-gray-600 italic">Loading AA logs...</p>
        ) : aaLogs.length === 0 ? (
          <p className="text-gray-500 italic">No AA remarks available.</p>
        ) : (
          <div className="overflow-x-auto shadow-md rounded-2xl border border-gray-200">
            <table className="min-w-full bg-gray-100 table table-stripped">
              <thead className="bg-gradient-to-r from-purple-600 to-purple-500 text-white rounded-t-2xl">
                <tr>
                  <th className="py-3 px-4 text-left text-xs font-semibold uppercase tracking-wider">
                    S.no
                  </th>
                  <th className="py-3 px-4 text-left text-xs font-semibold uppercase tracking-wider">
                    Remarks
                  </th>
                  <th className="py-3 px-4 text-left text-xs font-semibold uppercase tracking-wider">
                    Logs
                  </th>
                  <th className="py-3 px-4 text-left text-xs font-semibold uppercase tracking-wider">
                    Remark By
                  </th>
                  <th className="py-3 px-4 text-left text-xs font-semibold uppercase tracking-wider">
                    Date
                  </th>
                  <th className="py-3 px-4 text-left text-xs font-semibold uppercase tracking-wider">
                    Time
                  </th>
                </tr>
              </thead>
              <tbody>
                {aaLogs.map((log) => (
                  <tr
                    key={log.sno}
                    className={`${
                      log.sno % 2 === 0 ? "bg-gray-50" : "bg-white"
                    } hover:bg-purple-50 transition`}
                  >
                    <td className="py-3 px-4 text-gray-700 font-medium">
                      {log.sno}
                    </td>
                    <td className="py-3 px-4">{log.remarks}</td>
                    <td className="py-3 px-4">{log.logs}</td>
                    <td className="py-3 px-4">{log.remarkBy}</td>
                    <td className="py-3 px-4">{log.date}</td>
                    <td className="py-3 px-4">{log.time}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}